import { ComponentsProps } from '@mui/material';
import { TypographyOptions } from '@mui/material/styles/createTypography';
import { COLOR_BLACK, COLOR_GRAY, COLOR_GREEN, COLOR_WHITE } from 'theme/colors';

import { COLOR_BLACK_ALPHA, COLOR_GRAY_SEMILIGHT } from '../colors/colors.constant';

export enum FontWeights {
  fontWeightLight = 300,
  fontWeightRegular = 400,
  fontWeightMedium = 500,
  fontWeightSemiBold = 600,
  fontWeightBold = 700,
}

export enum FontFamilies {
  primary = '"Helvetica Neue", sans-serif',
  secondary = '"Inter", sans-serif',
}

export const fontVariations = {
  '&.font-primary': {
    fontFamily: FontFamilies.primary,
  },
  '&.font-secondary': {
    fontFamily: FontFamilies.secondary,
  },
};

export const colorVariations = {
  '&.white': {
    color: COLOR_WHITE,
  },
  '&.green': {
    color: COLOR_GREEN,
  },
  '&.black': {
    color: COLOR_BLACK,
  },
  '&.gray': {
    color: COLOR_GRAY,
  },
  '&.lightGray': {
    color: COLOR_GRAY_SEMILIGHT,
  },
};

export const getTypographyOptions = (): TypographyOptions => ({
  fontFamily: '"Helvetica Neue", sans-serif',

  allVariants: {
    color: COLOR_BLACK,
    fontWeight: FontWeights.fontWeightRegular,
    textAlign: 'left',
    fontStyle: 'normal',
    ...colorVariations,
    ...fontVariations,
  },

  h1: {
    fontSize: '142px',
    lineHeight: '120px',
    fontWeight: FontWeights.fontWeightLight,
  },

  h2: {
    fontSize: '48px',
    lineHeight: '58px',
    fontWeight: FontWeights.fontWeightLight,
  },

  h3: {
    fontSize: '36px',
    lineHeight: '42px',
    fontWeight: FontWeights.fontWeightLight,
  },

  h4: {
    fontSize: '40px',
    lineHeight: '48px',
    fontWeight: FontWeights.fontWeightRegular,
  },

  h5: {
    fontSize: '23px',
    lineHeight: '29px',
    fontWeight: FontWeights.fontWeightRegular,
  },

  body1: {
    fontSize: '17px',
    lineHeight: '24px',
    fontWeight: FontWeights.fontWeightRegular,
    '&.s': {
      fontSize: '14px',
      lineHeight: '17px',
    },
    '&.xs': {
      fontSize: '16px',
      lineHeight: '19px',
    },
    '&.m': {
      fontSize: '20px',
      lineHeight: '25px',
    },
    '&.l': {
      fontSize: '24px',
      lineHeight: '32px',
    },
    '&.xl': {
      fontSize: '32px',
      lineHeight: '42px',
    },
  },

  body2: {
    fontSize: '16px',
    lineHeight: '26px',
    fontWeight: FontWeights.fontWeightMedium,
  },

  caption: {
    fontSize: '14px',
    lineHeight: '17px',
    fontWeight: FontWeights.fontWeightMedium,
    color: COLOR_BLACK_ALPHA,
    fontFamily: FontFamilies.secondary,
  },

  subtitle1: {
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: FontWeights.fontWeightBold,
    fontFamily: FontFamilies.secondary,
  },
});

export const getMuiTextFieldDefaultProps = (): ComponentsProps['MuiTypography'] => ({
  variant: 'body1',
});
